import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useState } from "react";
import SoftInput from "components/SoftInput";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Table from "examples/Tables/Table";
import ReportedUsersRow, { columns } from "store/action/Reportedusers";
import useStore from "store/hook";
import { toast } from "react-toastify";
import { FadeLoader } from "react-spinners";
import emptyReportedusers from "assets/images/users/emptyreportedusers.png";
import SoftPagination from "components/SoftPagination";
import ChangeStatus from "layouts/universitydetails.js/components/changeStatus";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import { useGetreporteduserslistQuery } from "store/api/users.api";
import ActivateDeactivateUser from "layouts/users/components/ActivateDeactivateuser";

function ReportedUsers() {
  const [univesityData, setUniversitydata] = useState([]);
  const [reportedUsers, setReportedUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [tolatPages, setTotalpages] = useState(0);
  const [totalUniversities, setTotalUniversities] = useState(0);
  const [regex, setRegex] = React.useState("");
  const [newRegex, setNewRegex] = React.useState("");
  const { store, setDialogue } = useStore();


  const logout = useLogout();

  const debouncedSetRegex = React.useCallback(
    debounce((value) => {
      setPage(1);
      setNewRegex(value);
    }, 1000),
    []
  );

  React.useEffect(() => {
    debouncedSetRegex(regex);
  }, [regex, debouncedSetRegex]);

  const { data, isLoading, isFetching, error, refetch } = useGetreporteduserslistQuery({
    page: page,
    limit: 20,
    type: newRegex ? "search" : "list",
    searchText: newRegex,
  });


  React.useEffect(() => {
    if (data?.status === 1) {
      setUniversitydata(data?.data?.reportedUsers);
      setReportedUsers(data?.data?.reportedUsers);
      setTotalpages(data?.data?.totalPages);
      setTotalUniversities(data?.data?.totalSchools);
    } else if (data?.status == 0) {
      toast.error(Formatmessage(data?.message));
    } else if (data?.status == 10) {
      logout();
    }
  }, [data]);

  const rows = React.useMemo(
    () =>
      reportedUsers
        ? reportedUsers?.map((users) => ReportedUsersRow(users, setDialogue))
        : [],
    [reportedUsers]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        sx={{
          pr: { xs: 1, sm: 2, md: 4 },
          pl: { xs: 1, sm: 2, md: 2 },
          top: { xs: "55%", sm: "40%" },
        }}
        position="absolute"
        width="100%"
      >
        <SoftBox
          border="1px solid #D8E0E8"
          width="100%"
          borderRadius="md"
          sx={{ backgroundColor: "white.main" }}
        >
          <SoftBox
            sx={{ p: 2 }}
            gap={2}
            display="flex"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-between"
          >
            <SoftBox display="flex" sx={{ alignItems: "center", justifyContent: "start", gap: 2 }}>
              <SoftTypography sx={{ fontSize: 16, fontWeight: "medium", color: "black.main" }}>
                Reported Users
              </SoftTypography>

              <SoftBox borderRadius="xl" sx={{ backgroundColor: "skyblue.main", px: 2, py: 0.1 }}>
                <SoftTypography sx={{ fontSize: 16, fontWeight: "medium", color: "primary.main" }}>
                  {totalUniversities}
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox
              display="flex"
              flexWrap="wrap"
              sx={{ alignItems: "center", justifyContent: "start", gap: 2 }}
            >
              <SoftBox
                sx={{ position: "relative", height: "45px", width: { xs: "100%", sm: "230px" } }}
              >
                {/* Icon Button */}
                <SoftBox
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "5px",
                    transform: "translateY(-50%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <IconButton
                    sx={{
                      transition: "0.3s ease-in-out",
                    }}
                  >
                    <SearchIcon sx={{ color: "black.main", width: 20, height: 20 }} />
                  </IconButton>
                </SoftBox>

                <SoftInput
                  name="search"
                  type="text"
                  value={regex}
                  onChange={(e) => setRegex(e.target.value)}
                  placeholder="Search by school or  name"
                  fontSize="14px"
                  sx={{
                    width: "100% !important",
                    py: "10px",
                    pl: "40px",
                  }}
                />
              </SoftBox>
            </SoftBox>
          </SoftBox>

          {isLoading || isFetching ? (
            <SoftBox
              sx={{
                height: "calc(60vh)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FadeLoader color="#3DC2EB" />
            </SoftBox>
          ) : (
            <SoftBox>
              {reportedUsers?.length > 0 ? (
                <SoftBox
                  sx={{
                    "& .MuiTableRow-root:not(:last-child)": {
                      "& td": {
                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                          `${borderWidth[1]} solid ${borderColor}`,
                      },
                    },
                  }}
                >
                  <Table columns={columns} rows={rows} />
                </SoftBox>
              ) : (
                <SoftBox
                  sx={{
                    height: "calc(70vh)",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <SoftBox
                    display="flex"
                    flexDirection="column"
                    gap={8}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                  >
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      width="100%"
                      sx={{
                        backgroundColor: "skyblue.main",
                      }}
                    >
                      {columns.map(({ name, align, width }, index) => (
                        <SoftBox
                          key={index}
                          width={width}
                          align={align}
                          fontWeight="medium"
                          fontSize="14px"
                          py="10px"
                          px="24px"
                          color="black"
                          sx={{ fontWeight: 500, textTransform: "capitalize" }}
                        >
                          {name}
                        </SoftBox>
                      ))}
                    </SoftBox>

                    <SoftBox display="flex" flexDirection="column" alignItems="center">
                      <SoftBox
                        height="200px"
                        width="200px"
                        borderRadius="lg"
                        sx={{
                          backgroundImage: `url(${emptyReportedusers})`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "contain",
                        }}
                      />

                      <SoftTypography fontWeight="bold" color="black" sx={{ fontSize: 20 }}>
                        No Reported Users
                      </SoftTypography>
                      <SoftTypography fontWeight="medium" color="gray" sx={{ fontSize: 12 }}>
                       Currently, no users have been reported. All accounts are in good standing.
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              )}
            </SoftBox>
          )}
        </SoftBox>
        <SoftPagination Totalpages={tolatPages || 0} currentPage={page} changePage={setPage} />
        <ActivateDeactivateUser/>
      </SoftBox>
    </DashboardLayout>
  );
}

// Debounce function
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default ReportedUsers;
